import { config } from '../../config'
import { CALL_API, METHOD_TYPE } from '../../middleware/api.middleware'

/**
 * Contact Matches (from Cortera)
 */
export const GET_CONTACT_MATCH_REQUEST = 'GET_CONTACT_MATCH_REQUEST'
export const GET_CONTACT_MATCH_SUCCESS = 'GET_CONTACT_MATCH_SUCCESS'
export const GET_CONTACT_MATCH_FAILURE = 'GET_CONTACT_MATCH_FAILURE'
export const CONTACT_MATCH_PUSHER_MESSAGE = 'CONTACT_MATCH_PUSHER_MESSAGE'

/**
 * Get contact matches from cortera
 * @param params.securityId
 * @param params.userId - required for pusher
 * @param options
 * @return {{}}
 * @private
 */
const _getContactMatches = (params, options = {}) => {
  const { securityId, userId } = params

  return {
    [CALL_API]: {
      types: options.types || [
        GET_CONTACT_MATCH_REQUEST,
        GET_CONTACT_MATCH_SUCCESS,
        GET_CONTACT_MATCH_FAILURE
      ],
      method: METHOD_TYPE.GET,
      endpoint: `/contact/security/${securityId}/matches`,
      payload: {
        channelId: `private-contactadmin-${config.env}-${userId}`,
        eventId: CONTACT_MATCH_PUSHER_MESSAGE
      },
      req: params
    }
  }
}

/**
 * Dispatch GET_CONTACT_MATCH_REQUEST
 */
export const getContactMatches = (params, options) => (dispatch) => {
  return dispatch(_getContactMatches(params, options))
}
